export default __webpack_public_path__ + "static/media/2.9b2a8429.png";